<template>
    <div class="container">
        <div class="give-me-space" id="login">
            <div class="d-flex align-center justify-center" style="margin-left: 0;">
                <div  style="display: inline-block;">
                    <p style="color: black; font-weight: 500; font-size: 50px;">Verify your email</p>
                    <p style="color: black; font-weight: 500; font-size: 15px; display: inline-block;">If you dont have any massage on your email click link bellow</p>
                    <my-form @submit.prevent="resend()" ref="form">
                        <div>
                            <div class="mb-1">
                                <label>{{$t('Email')}}</label>
                            </div>
                            <v-text-field
                                outlined
                                dense
                                color="blue_drop"
                                :error="(errors && errors.email)? true : false"
                                :error-messages="errors.email"
                                name="login"
                                placeholder="Enter your email account"
                                type="text"
                                v-model="email"
                                :rules="[validationRules.email, validationRules.required]"
                            ></v-text-field>
                        </div>
                        <div class="d-flex justify-end flex-column">
                            <primary-button @clickBtn="resend" :activeButton="true">{{$t('Send request!')}}</primary-button>
                            <router-link to="/login" class="mt-2" style="font-size: 0.8rem; text-decoration: none;">{{$t("Back to login")}}</router-link>
                        </div>
                    </my-form>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {resend} from "../../api/user";

export default {
    data(){
        return{
            messages: [],
            email: null
        }
    },
    methods:{
        resend(){
            if(this.$refs.form.my_validate()){
                let data = {
                    email: this.email
                }
                resend(data).then(response => {
                    if(response == 'sent'){
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Email successfully sent'), type: 'info'});
                        this.$router.push('/login');
                    } else if(response == 'verified'){
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('User already verified.'), type: 'info'});
                    } else if(response == 'user_not_found'){
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('User not found.'), type: 'error'});
                    }
                    this.messages = response;
                })
            }
        }
    }
}
</script>
